import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IIamSource } from '@core/interfaces/iam/iam-source.interface';
import { tap, map } from 'rxjs/operators';
import { StoreService } from '../store/store.service';
import { AAGUID, parseArray } from '@interticket/core';
import { GuestToken } from '@core/models/auth/guest-token.model';
import { UserProfile } from '@core/models/user/user-profile.model';
import { AdminPartner } from '@core/models/iam/admin-partner.model';
import { Customer } from '../../models/customer/customer.model';

@Injectable()
export class IamService {

  constructor(
    private iamSource: IIamSource,
    private storeService: StoreService
  ) { }

  fetchFeatures(): Observable<string[]> {
    return this.iamSource.fetchFeatures()
      .pipe(
        tap(features => this.storeService.features = features)
      );
  }

  fetchGuestToken(): Observable<GuestToken> {
    const userId: AAGUID = this.storeService.guestToken?.userId;

    return this.iamSource.fetchGuestToken(userId)
      .pipe(
        map(guestToken => new GuestToken(guestToken)),
        tap(guestToken => this.storeService.guestToken = guestToken)
      );
  }

  getProfile(): Observable<UserProfile> {
    return this.iamSource.getProfile()
      .pipe(
        map(userProfile => new UserProfile(userProfile)),
        tap(userProfile => this.storeService.userProfile = userProfile)
      );
  }

  updateCustomer(customer: Customer): Observable<Response> {
    return this.iamSource.updateCustomerDatas(customer)
      .pipe(
        tap(() => this.storeService.userProfile = { ...this.storeService.userProfile, customer })
      );
  }

  getAdminPartners(): Observable<AdminPartner[]> {
    return this.iamSource.getAdminPartners()
      .pipe(
        map(availableAdminPartners => parseArray(availableAdminPartners, AdminPartner)),
        tap(availableAdminPartners => this.storeService.availableAdminPartners = availableAdminPartners)
      );
  }

}
